// Create this file as src/utils/withRouter.js

import { useParams, useNavigate } from 'react-router-dom';

// Higher Order Component to wrap class component with React Router v6 hooks
function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		let params = useParams();
		let navigate = useNavigate();
		return (
			<Component
				{...props}
				match={{ params }}
				history={{ 
					goBack: () => navigate(-1), 
					replace: (path) => navigate(path, { replace: true }),
					length: window.history.length
				}}
			/>
		);
	}

	return ComponentWithRouterProp;
}

export default withRouter;